import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsEyeSlash, BsEye } from 'react-icons/bs';
import './style.css';

const InputAuth = (props) => {
  const { inputHasErrors, type } = props;

  const { t, i18n } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="input-container-auth">
      <div className="input-auth">
        <input
          className={`form-control pt-3 pb-3 ${inputHasErrors ? 'is-invalid' : ''} `}
          {...props}
          {...(type === 'password' && showPassword && { type: 'text' })}
        />
        {type === 'password' && (
          <div className="show-password-container">
            {showPassword ? (
              <BsEyeSlash
                style={{ cursor: 'pointer', pointerEvents: 'visible' }}
                onClick={() => setShowPassword(!showPassword)}
              />
            ) : (
              <BsEye style={{ cursor: 'pointer', pointerEvents: 'visible' }} onClick={() => setShowPassword(!showPassword)} />
            )}
          </div>
        )}
      </div>
      {inputHasErrors && <div className="invalid-feedback">{t(inputHasErrors)}</div>}
    </div>
  );
};

export default InputAuth;
